var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _g5, _path22, _path23, _rect2, _g6, _path24, _path25, _rect3, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 52,
    viewBox: "0 0 107 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_24903)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.784 40.5784H103.552V39.4799H103.135V39.2656H104.201V39.4799H103.784V40.5784Z",
    fill: "#D91470"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 40.2559H105.197L104.787 39.6412V40.5784H104.557V39.2656H104.803L105.202 39.8868L105.603 39.2656H105.848V40.5784H105.619V39.6368L105.204 40.2559Z",
    fill: "#D91470"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2502 8.51037C45.8696 8.51037 40.6901 13.674 40.6741 20.0573C40.6575 26.451 45.8267 31.6472 52.2204 31.6652C58.6134 31.6805 63.8103 26.5113 63.8276 20.1183C63.8297 19.1829 63.7188 18.2746 63.5114 17.403C62.3105 17.9557 60.8717 17.9432 59.6396 17.2435L56.2274 21.7707C56.6539 22.2671 56.8896 22.8884 56.9139 23.5263C56.9354 24.0928 56.7918 24.6718 56.4604 25.1849C55.6062 26.5078 53.8352 26.8871 52.5137 26.0301C52.0574 25.7354 51.7156 25.3312 51.4958 24.8756C51.1116 24.0775 51.1047 23.1207 51.5415 22.2962L48.7957 20.2293L47.9429 21.3622L44.8018 18.9978L47.1663 15.8561L50.3073 18.2205L49.4551 19.3528L52.2315 21.4427C53.0975 20.7174 54.3352 20.5593 55.3676 21.0904L58.7645 16.5814C57.4083 15.2529 57.065 13.1297 58.0649 11.4157C58.2625 11.0766 58.501 10.7798 58.768 10.5184C56.9194 9.25714 54.6867 8.5173 52.2807 8.51037H52.2502Z",
    fill: "url(#paint0_radial_1014_24903)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7676 10.5184C58.7686 10.5195 58.7697 10.5205 58.7707 10.5205C58.7697 10.5205 58.7686 10.5195 58.7676 10.5184Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.850006
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 14,
    width: 26,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4513 14.3135L64.8641 17.691L62.5073 34.0286L39.0938 30.6504L41.4513 14.3135Z",
    fill: "url(#paint1_linear_1014_24903)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1524 20.0963C41.151 20.1525 41.1504 20.21 41.1497 20.2669V20.4174C41.194 25.5859 45.8044 30.893 52.0677 30.9097H52.1093C58.4496 30.9034 62.8901 25.5997 62.949 20.2357V20.0915C62.9053 18.236 60.5721 21.5254 56.9145 23.5258C56.936 24.0923 56.7924 24.6713 56.4603 25.1844C55.606 26.5067 53.8351 26.8867 52.5135 26.0303C52.0573 25.7343 51.7155 25.3314 51.4957 24.8751C46.3674 24.5229 42.6044 19.4896 41.4915 19.4889C41.2807 19.4889 41.1642 19.6692 41.1524 20.0963Z",
    fill: "url(#paint2_linear_1014_24903)"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3631 10.6272C67.862 12.4931 65.1307 12.7913 63.2655 11.2894C61.4003 9.78546 61.1028 7.05907 62.6047 5.1904C64.1059 3.32589 66.8344 3.02912 68.7016 4.53307C70.5689 6.03009 70.8629 8.76272 69.3631 10.6272Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 6,
    width: 21,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2583 6.64673L60.0748 9.48819L58.3448 20.3369L40.5283 17.4961L42.2583 6.64673Z",
    fill: "url(#paint3_linear_1014_24903)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8855 9.38185C48.1265 9.73756 45.5512 11.3213 44.0459 13.0693C42.4733 14.7674 41.8638 16.3282 41.8389 16.408C51.7154 10.3741 53.702 16.2949 57.9185 17.7046L58.7644 16.5806C57.4081 15.2521 57.0649 13.1296 58.0648 11.4149C58.1237 11.3129 58.1937 11.2221 58.2596 11.1285C56.5844 9.98652 54.4155 9.27927 52.2715 9.27927C51.8063 9.27927 51.3424 9.31252 50.8855 9.38185Z",
    fill: "url(#paint4_linear_1014_24903)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 16,
    width: 4,
    height: 3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7651 17.4171L60.8078 16.334L61.6177 17.8622L59.575 18.9453L58.7651 17.4171Z",
    fill: "url(#paint5_linear_1014_24903)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0923 17.9684C59.7531 18.0363 60.4777 17.987 61.2896 17.7728C60.7245 17.7145 60.1629 17.5405 59.6387 17.2431L59.0923 17.9684Z",
    fill: "url(#paint6_linear_1014_24903)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 2,
    width: 35,
    height: 36
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2461 2.24071L66.7834 28.4409L43.1785 37.9341L32.6418 11.7338L56.2461 2.24071Z",
    fill: "url(#paint7_linear_1014_24903)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2502 8.5104C45.8696 8.5104 40.6901 13.674 40.6741 20.0573C40.6575 26.451 45.8267 31.6473 52.2204 31.6653L52.5137 26.0302C51.2593 25.2189 50.8551 23.5908 51.5415 22.2963L48.7957 20.2293L47.9429 21.3623L44.8018 18.9978L47.1663 15.8561L50.3073 18.2205L49.4551 19.3529L52.2315 21.4427C53.0975 20.7174 54.3352 20.5593 55.3676 21.0905L58.7645 16.5814C57.4083 15.2529 57.065 13.1297 58.0649 11.4157C58.2625 11.0766 58.501 10.7798 58.768 10.5184C56.9194 9.25717 54.6867 8.51733 52.2807 8.5104H52.2502Z",
    fill: "url(#paint8_linear_1014_24903)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04321 44.0514V44.0243C5.04321 41.3241 7.07781 39.1121 9.9955 39.1121C11.7866 39.1121 12.858 39.7094 13.74 40.5774L12.411 42.1109C11.6784 41.4464 10.9316 41.0384 9.98251 41.0384C8.38189 41.0384 7.22715 42.3685 7.22715 43.9972V44.0243C7.22715 45.652 8.35484 47.0091 9.98251 47.0091C11.0669 47.0091 11.7325 46.5741 12.4781 45.8955L13.8082 47.2396C12.8309 48.2851 11.7465 48.9344 9.91325 48.9344C7.11785 48.9344 5.04321 46.7786 5.04321 44.0514",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4749 39.2744H17.5646V43.033H21.4195V39.2744H23.5093V48.7731H21.4195V44.9605H17.5646V48.7731H15.4749V39.2744Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0396 39.2744H33.2039V41.1348H28.1142V43.0611H32.5925V44.9193H28.1142V46.9139H33.271V48.7731H26.0396V39.2744Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7104 44.0514V44.0243C34.7104 41.3241 36.7461 39.1121 39.6617 39.1121C41.4517 39.1121 42.5263 39.7094 43.4062 40.5774L42.0772 42.1109C41.3445 41.4464 40.5978 41.0384 39.6476 41.0384C38.047 41.0384 36.8944 42.3685 36.8944 43.9972V44.0243C36.8944 45.652 38.0188 47.0091 39.6476 47.0091C40.7331 47.0091 41.3975 46.5741 42.1454 45.8955L43.4743 47.2396C42.4971 48.2851 41.4127 48.9344 39.5805 48.9344C36.7862 48.9344 34.7104 46.7786 34.7104 44.0514",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0217 39.2744H47.1126V43.4269L50.9643 39.2744H53.4891L49.6212 43.3046L53.6666 48.7731H51.1558L48.2111 44.7289L47.1126 45.8695V48.7731H45.0217V39.2744Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0303 44.0644C63.0747 44.0644 63.6839 43.4399 63.6839 42.6272V42.6001C63.6839 41.664 63.0335 41.1607 61.9892 41.1607H60.3745V44.0643L62.0303 44.0644ZM58.2869 39.2744H62.1645C64.4307 39.2744 65.8019 40.6185 65.8019 42.559V42.5849C65.8019 44.784 64.093 45.9225 61.961 45.9225H60.3745V48.7731H58.2869V39.2744Z",
    fill: "#D91470"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0699 44.0514V44.0243C75.0699 42.3955 73.873 41.0384 72.1922 41.0384C70.5094 41.0384 69.3427 42.3685 69.3427 43.9972V44.0243C69.3427 45.652 70.5364 47.0091 72.2193 47.0091C73.9043 47.0091 75.0699 45.679 75.0699 44.0514M67.1577 44.0514V44.0243C67.1577 41.3241 69.2886 39.1121 72.2193 39.1121C75.1489 39.1121 77.2528 41.2971 77.2528 43.9972V44.0243C77.2528 46.7245 75.1229 48.9344 72.1922 48.9344C69.2627 48.9344 67.1577 46.7515 67.1577 44.0514Z",
    fill: "#D91470"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2874 39.2744H81.375V48.7731H79.2874V39.2744Z",
    fill: "#D91470"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0005 39.2744H85.9279L90.3792 45.1217V39.2744H92.4397V48.7731H90.6649L86.0632 42.7343V48.7731H84.0005V39.2744Z",
    fill: "#D91470"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1811 41.2019H94.2915V39.2744H102.161V41.2019H99.2741V48.7731H97.1811V41.2019Z",
    fill: "#D91470"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7239 10.5886C58.7256 10.5903 58.7272 10.5903 58.7272 10.5919C58.7272 10.5903 58.7256 10.5903 58.7239 10.5886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 115,
    height: 63
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.993 0.802734H2.27271V62.4975H116.993V0.802734Z",
    fill: "black",
    fillOpacity: 0.850006
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1014_24903)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 1,
    height: 1
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.1262,
    y: 19.3677,
    width: 0.432021,
    height: 0.229682,
    transform: "rotate(-8.06054 41.1262 19.3677)",
    fill: "url(#pattern0)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0821 19.437H41.1951V31.0731H63.0821V19.437Z",
    fill: "url(#paint9_linear_1014_24903)"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7239 10.5886C58.7256 10.5903 58.7272 10.5903 58.7272 10.5919C58.7272 10.5903 58.7256 10.5903 58.7239 10.5886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 115,
    height: 63
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.993 0.802734H2.27271V62.4975H116.993V0.802734Z",
    fill: "black",
    fillOpacity: 0.850006
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1014_24903)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 1,
    height: 1
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1262,
    y: 19.3677,
    width: 0.432021,
    height: 0.229682,
    transform: "rotate(-8.06054 41.1262 19.3677)",
    fill: "url(#pattern1)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0821 19.437H41.1951V31.0731H63.0821V19.437Z",
    fill: "url(#paint10_linear_1014_24903)"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7239 10.5886C58.7256 10.5903 58.7272 10.5903 58.7272 10.5919C58.7272 10.5903 58.7256 10.5903 58.7239 10.5886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 115,
    height: 63
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.993 0.802734H2.27271V62.4975H116.993V0.802734Z",
    fill: "black",
    fillOpacity: 0.850006
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1014_24903)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1014_24903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 1,
    height: 1
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1262,
    y: 19.3677,
    width: 0.432021,
    height: 0.229682,
    transform: "rotate(-8.06054 41.1262 19.3677)",
    fill: "url(#pattern2)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1014_24903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0821 19.437H41.1951V31.0731H63.0821V19.437Z",
    fill: "url(#paint11_linear_1014_24903)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1014_24903",
    transform: "scale(0.0126582 0.0238095)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1014_24903",
    transform: "scale(0.0126582 0.0238095)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1014_24903",
    transform: "scale(0.0126582 0.0238095)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1014_24903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6062 18.3533) rotate(-11.1606) scale(16.8512 16.8512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C40047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887341,
    stopColor: "#FF0070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1014_24903",
    x1: 44.0834,
    y1: 23.3653,
    x2: 58.0554,
    y2: 25.3812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209604,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995283,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1014_24903",
    x1: 44.0834,
    y1: 23.3653,
    x2: 58.0554,
    y2: 25.3812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209604,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995283,
    stopColor: "#B81E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1014_24903",
    x1: 46.5055,
    y1: 12.6925,
    x2: 70.0936,
    y2: 16.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00606061,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0831384,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608227,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1014_24903",
    x1: 46.5055,
    y1: 12.6923,
    x2: 70.0937,
    y2: 16.4542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00606061,
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0831384,
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608227,
    stopColor: "#F1F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1014_24903",
    x1: 46.8698,
    y1: 24.7127,
    x2: 63.8818,
    y2: 15.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00606061,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186424,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515152,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82922,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1014_24903",
    x1: 46.8697,
    y1: 24.7127,
    x2: 63.8817,
    y2: 15.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00606061,
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186424,
    stopColor: "#D31C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515152,
    stopColor: "#ED3B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82922,
    stopColor: "#EDC6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDC6D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1014_24903",
    x1: 45.6642,
    y1: 6.34112,
    x2: 52.1552,
    y2: 22.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0638202,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986078,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1014_24903",
    x1: 45.6643,
    y1: 6.34121,
    x2: 52.1553,
    y2: 22.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0638202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986078,
    stopColor: "#FF93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1014_24903",
    x1: 40.7552,
    y1: 22.918,
    x2: 63.5769,
    y2: 26.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#D02684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#CF2684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#CF2683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#CF2681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#CE2581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CE257F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CD257D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CD257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#CC257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CC257B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CB2479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CB2478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#CB2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#CA2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#CA2476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#CA2475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#CA2474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#C92474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#C92473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#C92472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#C82371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#C7236F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#C7236E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#C7236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#C6236B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#C5226A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#C52269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#C52268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#C42267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C32265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C32264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C32263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C22162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C22161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C22160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C1215F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C1215E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C1215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C0215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C0215C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#C0215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#BF205A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#BF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#BF2058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#BE2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#BE2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#BD2055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#BD2054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#BD2053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#BC1F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#BC1F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#BC1F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#BB1F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#BB1F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#BA1F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#BA1F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#BA1F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1014_24903",
    x1: 40.7552,
    y1: 22.918,
    x2: 63.5769,
    y2: 26.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#D02684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#CF2684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#CF2683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#CF2681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#CE2581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CE257F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CD257D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CD257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#CC257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CC257B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CB2479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CB2478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#CB2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#CA2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#CA2476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#CA2475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#CA2474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#C92474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#C92473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#C92472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#C82371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#C7236F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#C7236E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#C7236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#C6236B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#C5226A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#C52269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#C52268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#C42267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C32265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C32264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C32263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C22162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C22161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C22160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C1215F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C1215E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C1215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C0215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C0215C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#C0215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#BF205A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#BF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#BF2058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#BE2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#BE2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#BD2055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#BD2054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#BD2053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#BC1F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#BC1F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#BC1F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#BB1F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#BB1F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#BA1F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#BA1F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#BA1F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1014_24903",
    x1: 40.7552,
    y1: 22.918,
    x2: 63.5769,
    y2: 26.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#D02685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#D02684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#CF2684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#CF2683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#CF2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#CF2681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#CE2581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#CE2580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CE257F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CD257E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CD257D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CD257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#CC257C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CC257B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CC257A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CB2479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CB2478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#CB2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#CA2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#CA2476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#CA2475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#CA2474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#C92474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#C92473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#C92472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#C82371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#C82370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#C7236F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#C7236E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#C7236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#C6236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#C6236B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#C5226A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#C52269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#C52268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#C42267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C42266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C32265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C32264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C32263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C22162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C22161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C22160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C1215F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C1215E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C1215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C0215D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C0215C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#C0215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#BF205A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#BF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#BF2058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#BE2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#BE2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#BD2055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#BD2054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#BD2053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#BC1F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#BC1F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#BC1F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#BB1F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#BB1F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#BA1F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#BA1F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#BA1F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B91E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B91E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B81E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81E47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_24903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.708,
    height: 50.9022,
    fill: "white",
    transform: "translate(0.248535 0.802734)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1014_24903",
    width: 79,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAAAqCAYAAADyDQZvAAAABmJLR0QA/wD/AP+gvaeTAAAEp0lEQVRoge3az2sdVRQH8E9e0tgYbS2GaqtFKVa0CzctulBEtCCKKIoIXSjYpSguFEH8C9xVXLkvuGhdCYoiKLioSEEtFXVjUZCqtTam1f5Im+fivCHTyZ335sdLXiJ+4TAz987ce+Y759xz7r0z7n/UwRT24UF8MWJd1hTux3F0e3LvaNVZGxjD65i3SFwXe0ep1FrARrzvStIyeXKEeq167MC30sR1sWd0qq1uPILTyonr4u6RabdKMYY3cFl/4rrYPiIdVyWmcdBg0ro4j/EmnYwNQ9NVhu34RjXiujjWtKMOJvx3SNyLWdWJ6+K9pp11sA7rBYlrFVN4Sz3SMnm1aafjFsmb7imx1qxwF37QjLgudjfteByTgrRrRCK5qVe22jElouk5zYmb1SJYFMm7DjO4QZDYqOEVwGP4ThBXJRUpk0NZg03GrLGC5MuncS3m8Fevs1HjeuwXie+kpXrXxbvZSV3yUp0WlekIS5wRJv4nFmr2M0zchYd6522Jm8MH2UVTy0spUrTICWzFjTiJP4S7rDQ2JnRrSuAh4fZonmqkSCvWZ2VX4VaRiM7iVzFvXCnsLOjTlLgu3s4XtHXbMsuTOJ8QVrgNlwSBp/C7mO4sF/YYjtV9jK/zBW0DRvG6X13++mrhTjtEznge//TkLH40HOvchdsTejTBm8WCOuSVBYtB95cRmb9vg4iK63qyEwe0i9ZjeC3RdxMCP8OnxcJOA4XqWh5LlS5LdTLZqv0ewQtiza1tsLiMl1MVdcirkqYUy6sSnSL5Ac2nQU/hpT5t18E7OJqqqDMbGBNkZ7OMTk7GC9IpOVaRidzxTpF0H1ctzVkvrOQV4f4TCanzzifwjFx6kkebPC8775emVP3qZe7eEe67W4w5R3Am8fwmsZe6T7h8sc0maUoXz4uMIIk2AaNOmlI3MhdlA54Wa2+/iUh8Tsyrb8YdIp8sTr/ajHf78VG/G5rkeW3TlKpjXuq5Dm7BbYKoTDoV2qxD3Jdir7Yv6kbbPAa5YfFYJbgUr+tacBUZhJ/wBC4MurEOed2EEoOsiKVKV3XZfu3XJasqeXN4XEwhB6IOeQuujHhlijSxln73VmlnUPtViDsriEumJSnUHfMu9ZTInqv6petaSOqZsjKWEjOo7SJm8SgOl9Qn0WTMmxdz0ZQyVdy2iKbEN6lL4aRIc2oRR/OAcVGMDwslytVx2351ba15EHlf4Z7esTbaRNtsWeli73pY5Cg5thkGUsQdwH1i9tIIbcgjAsgpYYXZCkgdt21rgU0IPIXn8KxYAmuMYWxaZ9txf2OLmFNWddtiuZJjG1fNy0G8KBZgW6Ot5eUxj5/xi0gwq770oPo6Y1jZfUfwsJjkD4U4lud3idPCEmfEVCqzxOLLVh3z+o1fgz7EMbEC/GHLd0piuf416YoU4KRY8dgmVjv6EUDaaorlZfdlcgGfiP3Vzy3j3vFK/KhzuiffixWQLbjJ4goI1V25rPyMSDcOi42as8v5QhlS48ZKoIPNYjdtpne+WWwMTQpXzx8nc9fzYtw6IcbXo+LDrPjG+qjIK8O0WJeb6smEIOWCWL87J70YOhL8C3vXFRHiCb5VAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpoint);
export default __webpack_public_path__ + "static/media/checkpoint.ff031f38f3a8a348f49fa6fde4190787.svg";
export { ForwardRef as ReactComponent };